import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  CircularProgress,
} from '@mui/material';
import { ArchiveOutlined as ArchiveIcon } from '@mui/icons-material';

export type ArchiveConfirmDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
  title?: string;
  message?: string;
};

export const ArchiveConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  loading = false,
  title,
  message,
}: ArchiveConfirmDialogProps) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth disableScrollLock>
      <DialogTitle>{title || 'Archive record?'}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {message || 'This record will be archived and hidden from the main list.'}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          disabled={loading}
          startIcon={loading ? <CircularProgress size={16} /> : <ArchiveIcon />}
        >
          {loading ? 'Archiving...' : 'Archive'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
